<template>
  <form @submit.prevent="submit()">
    <b-row>
      <b-col cols="12">
        <b-form-group>
          <label for="title">{{ $t('global.title') }}</label>
<!--          <model-select required id="item_input" :options="itemOptions" v-model="item.idItem"></model-select>-->
          <input type="text" id="title" class="form-control" v-model="item.title" :placeholder="$t('global.title')">
          <div v-if="isInvalid('title')" class="text-danger">
            {{ violations.title }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group>
          <label for="description">{{ $t('global.description') }}</label>
          <input type="text" id="description" class="form-control" v-model="item.description" :placeholder="$t('global.description')">
          <div v-if="isInvalid('description')" class="text-danger">
            {{ violations.description }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <label for="header">{{ $t('views.documenttemplates.form.header') }}</label>
          <input type="text" id="header" class="form-control" v-model="item.header" :placeholder="$t('views.documenttemplates.form.header')">
          <div v-if="isInvalid('header')" class="text-danger">
            {{ violations.header }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <label for="subheader">{{ $t('views.documenttemplates.form.subheader') }}</label>
          <input type="text" id="subheader" class="form-control" v-model="item.subheader" :placeholder="$t('views.documenttemplates.form.subheader')">
          <div v-if="isInvalid('subheader')" class="text-danger">
            {{ violations.subheader }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <trumbowyg ref="editor" v-model="item.htmlContent" :config="trumbowygConfig" class="form-control" name="priceRules">
        </trumbowyg>
      </b-col>
      <b-col cols="12">
        <b-form-group>
          <label for="templateType">{{ $t('views.documenttemplates.form.type') }}</label>
          <model-select required id="templateType" :options="templateOptions" v-model="item.templateType"></model-select>
          <div v-if="isInvalid('type')" class="text-danger">
            {{ violations.type }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-if="item.templateType === 1">
        <b-form-group>
          <label for="idDefaultBatchNumber">{{ $t('views.documenttemplates.form.idDefaultBatchNumber') }}</label>
          <model-select required id="idDefaultBatchNumber" :options="batchNumbers" v-model="item.idDefaultBatchNumber"></model-select>
          <div v-if="isInvalid('idDefaultBatchNumber')" class="text-danger">
            {{ violations.idDefaultBatchNumber }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-if="item.templateType === 2">
        <b-form-group>
          <label for="idCaseType">{{ $t('views.excmagreements.form.agreementCyclicTask.caseType') }}</label>
          <model-select required id="idCaseType" :options="caseTypeOptions" v-model="item.idCaseType"></model-select>
          <div v-if="isInvalid('idCaseType')" class="text-danger">
            {{ violations.idCaseType }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-if="item.templateType === 3">
        <b-form-group>
          <label for="idTaskType">{{ $t('views.excmagreements.form.agreementCyclicTask.taskType') }}</label>
          <model-select required id="idTaskType" :options="taskTypeOptions" v-model="item.idTaskType"></model-select>
          <div v-if="isInvalid('idTaskType')" class="text-danger">
            {{ violations.idTaskType }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <button type="button" class="btn btn-success" @click="submit()">{{ $t('buttons.submit') }}</button>
<!--    <button type="button" class="btn btn-success" @click="insertText()">{{ $t('buttons.submit') }}</button>-->
  </form>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min'
import { mapActions, mapGetters } from 'vuex'
import ApiService from '@/utils/ApiService'

export default {
  name: 'Form',
  props: ['values', 'initialValues', 'handleSubmit', 'violations'],
  components: {
    ModelSelect,
    Trumbowyg
  },
  data () {
    return {
      templateOptions: [
        {
          value: 0,
          text: this.$t('views.documenttemplates.form.forInvoice')
        },
        {
          value: 1,
          text: this.$t('views.documenttemplates.form.forAgreement')
        },
        {
          value: 2,
          text: this.$t('views.documenttemplates.form.forCase')
        },
        {
          value: 3,
          text: this.$t('views.documenttemplates.form.forTask')
        },
        {
          value: 4,
          text: this.$t('views.documenttemplates.form.forMessage')
        }
      ],
      taskTypeOptions: [],
      caseTypeOptions: [],
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdown
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          },
          insertText: {
            fn: () => this.insertText(),
            ico: 'blockquote'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['insertText']
        ],
        lang: this.$i18n.locale
      }
    }
  },
  computed: {
    ...mapGetters({
      batchNumberOptions: 'exsbinvoice/list/batchNumberOptions'
    }),
    batchNumbers () {
      let batchNumbers = this.batchNumberOptions.filter(entry => {
        return entry.agreementsAllowed === 1
      })
      batchNumbers.unshift({
        text: this.$t('global.notSet'),
        value: null
      })
      return batchNumbers
    },
    item () {
      return this.initialValues || this.values
    }
  },
  created () {
    this.fetchBatchNumberOptions()
    this.fetchTaskTypeOptions()
    this.fetchCaseTypes()
  },
  methods: {
    ...mapActions({
      fetchBatchNumberOptions: 'exsbinvoice/list/fetchBatchNumberOptions'
    }),
    async fetchTaskTypeOptions () {
      let params = { pagination: false }
      const response = await new ApiService('e_x_c_m_task_types', params).getResults()
      this.taskTypeOptions = response.items.map(type => {
        return {
          value: type['@id'],
          text: type.title + (type.idCasesType ? ' (' + type.idCasesType.title + ')' : '')
        }
      })
      this.taskTypeOptions.unshift({ text: this.$t('global.notSet'), value: null })
    },
    async fetchCaseTypes () {
      let params = { pagination: false }
      const response = await new ApiService('e_x_c_m_case_types', params).getResults()
      this.caseTypeOptions = response.items.map(entry => {
        return { value: entry['@id'], text: entry.title }
      })
      this.caseTypeOptions.unshift({ text: this.$t('global.notSet'), value: null })
    },
    submit () {
      this.$Swal({
        title: this.$t('views.documenttemplates.notifications.update.title'),
        text: this.$t('views.documenttemplates.notifications.update.text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.handleSubmit()
      })
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    insertText () {
      this.$refs.editor.el.trumbowyg('execCmd', {
        cmd: 'insertText',
        param: 'TextToInsert',
        forceCss: false
      })
    }
  }
}
</script>

<style scoped>

</style>
